/**
 * @file Move attendant
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { MoveBase } from './move';
import * as moment from 'moment';
var AttendantMove = /** @class */ (function (_super) {
    tslib_1.__extends(AttendantMove, _super);
    /**
     * Creates an instance of AttendantMove.
     */
    function AttendantMove(domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        return _super.call(this, 'attendant-move', 'APP.EXECUTORS.ATTENDANT_MOVE_NAME', ['Attendant'], 'Attendant', domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
    }
    /**
     * Validate the executor data
     * @protected
     * @param {ExecutorData} data The executor datea
     * @returns {Promise<any>}
     */
    AttendantMove.prototype.validate = function (data) {
        var _this = this;
        // Make sure we have valid resources
        return _super.prototype.validate.call(this, data).then(function () {
            return new Promise(function (resolve, reject) {
                if (!_this.targetDateIsTheSame(data.items[0], data.targets[0])) {
                    return reject('APP.EXECUTORS.MOVE_TO_OTHER_DAY_NOT_ALLOWED_MESSAGE');
                }
                resolve();
            });
        });
    };
    /**
     * Check if the attendant is moved to another date
     * @param {Entity} item The plan item
     * @param {ExecutorTimeslot} target The new target
     * @returns {boolean}
     */
    AttendantMove.prototype.targetDateIsTheSame = function (item, target) {
        var itemStart = moment(item['Start']);
        var targetStart = target.start;
        if (itemStart.dayOfYear() !== targetStart.dayOfYear()) {
            return false;
        }
        if (itemStart.year() !== targetStart.year()) {
            return false;
        }
        return true;
    };
    return AttendantMove;
}(MoveBase));
export { AttendantMove };
